module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('module-configuration', {
    attrs: {
      "data": _vm.config,
      "errors": _vm.errors
    }
  }, [_c('div', {
    staticClass: "l-row",
    attrs: {
      "slot": "auth"
    },
    slot: "auth"
  }, [_c('form-group', {
    attrs: {
      "label": "Ambiente",
      "required": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.auth.environment),
      expression: "config.auth.environment"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.auth, "environment", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "sandbox"
    }
  }, [_vm._v("Sandbox")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "production"
    }
  }, [_vm._v("Produção")])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Usuário"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.auth.user),
      expression: "config.auth.user"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.config.auth.user)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config.auth, "user", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Senha"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.auth.password),
      expression: "config.auth.password"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.config.auth.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config.auth, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Email Seller"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.auth.email),
      expression: "config.auth.email"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.config.auth.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config.auth, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "CNPJ Seller"
    }
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('##.###.###/####-##'),
      expression: "'##.###.###/####-##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.config.auth.cnpj),
      expression: "config.auth.cnpj"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.config.auth.cnpj)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config.auth, "cnpj", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.config.auth.accessToken) ? _c('form-group', {
    attrs: {
      "label": "Token",
      "columns": 6
    }
  }, [_vm._v("\n      " + _vm._s(_vm.config.auth.accessToken.substring(0, 50)) + "...\n      "), _c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.config.auth.accessToken),
      expression: "config.auth.accessToken",
      arg: "copy"
    }],
    staticClass: "btn btn--sm btn--info copy hint hint--top",
    attrs: {
      "type": "button",
      "data-label": "Clique para copiar"
    },
    on: {
      "click": function($event) {
        return _vm.copied()
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-copy2"
  })])]) : _vm._e()], 1), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Produtos"
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('product-price-configuration', {
    attrs: {
      "input": _vm.config.product.price
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Redutor de estoque padrão"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.product.stock.reducer),
      expression: "config.product.stock.reducer"
    }],
    staticClass: "form-input",
    attrs: {
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.config.product.stock.reducer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config.product.stock, "reducer", $event.target.value)
      }
    }
  })])], 1)]), _vm._v(" "), _c('panel', {
    attrs: {
      "title": _vm.$t('expediter.label')
    }
  }, [_c('expediter-configuration', {
    attrs: {
      "expediter": _vm.config.order.expediter
    }
  })], 1), _vm._v(" "), _c('panel', {
    attrs: {
      "title": _vm.$t('quotation.label')
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-6@md"
  }, [_c('quotation-configuration', {
    attrs: {
      "quotation": _vm.config.quotation,
      "marketplace": _vm.identifier
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Retorno de frete preferencial",
      "required": _vm.isPreferenceRequired
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.quotation.preferenceFreight),
      expression: "config.quotation.preferenceFreight"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.quotation, "preferenceFreight", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _vm._l((_vm.preferences), function(preference) {
    return _c('option', {
      domProps: {
        "value": preference
      }
    }, [_vm._v(_vm._s(_vm.$t((preference + ".label"))))])
  })], 2), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Critério para seleção do frete de exibição.")])])], 1)]), _vm._v(" "), _c('panel', {
    attrs: {
      "title": _vm.$t('order.label')
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('order-retrieve-date-configuration', {
    attrs: {
      "columns": 6,
      "orderConfigs": _vm.config.order
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Estimativa Entrega *",
      "columns": 3
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.order.defaultEstimatedDays),
      expression: "config.order.defaultEstimatedDays"
    }],
    staticClass: "form-input",
    attrs: {
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.config.order.defaultEstimatedDays)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config.order, "defaultEstimatedDays", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Quantidade de dias úteis, que o sistema irá acrescentar a data de postagem. Caso queira desativar informar 0 (ZERO)")])])], 1)]), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Sincronização"
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Sincronizar estoque",
      "columns": 3
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.synchronize.stock),
      expression: "config.synchronize.stock"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.synchronize, "stock", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.synchronizeOptions), function(option) {
    return _c('option', {
      key: option,
      domProps: {
        "value": option
      }
    }, [_vm._v(_vm._s(_vm.$t((option + ".label"))))])
  }), 0), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Define se os estoques serão sincronizados e atualizados na Integracommerce.")])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Sincronizar preço",
      "columns": 3
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.synchronize.price),
      expression: "config.synchronize.price"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.synchronize, "price", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.synchronizeOptions), function(option) {
    return _c('option', {
      key: option,
      domProps: {
        "value": option
      }
    }, [_vm._v(_vm._s(_vm.$t((option + ".label"))))])
  }), 0), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Define se os preços serão sincronizados e atualizados na Integracommerce.")])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a62234ac","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Configuration/Integracommerce.vue
// module id = 3390
// module chunks = 0